export default __webpack_public_path__ + "static/media/app_screenshot.3aeac5ac.png";